export class ErrorMessageResource {
    public static DUPLICATED_DOCUMENT = 'person:duplicated_document';
    public static INVALID_DOCUMENT = 'person:invalid_document';
}